import React from 'react';
import type CurrentUser from '../Models/CurrentUserModel';

export type UserContextProps = {
    currentUser: CurrentUser | null,
    setCurrentUser: (user: CurrentUser | null) => void,
    lastActivity: Date | null,
    setLastActivity: (value: Date | null) => void,
};

const UserContext: React.Context<UserContextProps> = React.createContext<UserContextProps>({
    currentUser: null,
    setCurrentUser: () => {},
    lastActivity: null,
    setLastActivity: () => {},
});

export default UserContext;